export const FORM_IDENTIFIER = 'app/CauseFormPage';

export const INIT = 'app/CauseFormPage/INIT';
export const INIT_SUCCESS = 'app/CauseFormPage/INIT_SUCCESS';
export const INIT_FAILED = 'app/CauseFormPage/INIT_FAILED';

export const SAVE = 'app/CauseFormPage/SAVE';
export const SAVE_SUCCESS = 'app/CauseFormPage/SAVE_SUCCESS';
export const SAVE_FAILED = 'app/CauseFormPage/SAVE_FAILED';

export const DUPLICATE = 'app/CauseFormPage/DUPLICATE';

export const REMOVE = 'app/CauseFormPage/REMOVE';
export const REMOVE_SUCCESS = 'app/CauseFormPage/REMOVE_SUCCESS';
export const REMOVE_FAILED = 'app/CauseFormPage/REMOVE_FAILED';
